import { render } from "./chartE.vue?vue&type=template&id=688b560f"
import script from "./chartE.vue?vue&type=script&lang=ts"
export * from "./chartE.vue?vue&type=script&lang=ts"
script.render = render

export default script